import { Controller } from "@hotwired/stimulus"
import { visibleItems, controllerFor } from "./cloud_helpers"

// L'inspector: carica il pannello del file nel turbo-frame #cloud_inspector.
// Frecce e bottoni passano al file precedente/successivo tra quelli visibili.
export default class extends Controller {
  static targets = ["frame", "panel", "prevBtn", "nextBtn"]

  open(item) {
    const url = item?.dataset.peekUrl
    if (!url || !this.hasFrameTarget) return
    this.currentId = item.dataset.itemId
    this.markInspected()
    if (this.frameTarget.src === new URL(url, window.location.origin).href && this.isOpen) return
    this.frameTarget.src = url
  }

  loaded() {
    if (!this.hasPanelTarget) return
    this.currentId = this.panelTarget.dataset.itemId
    this.markInspected()
    this.updateNav()
    this.element.classList.add("cloud--inspecting")
    requestAnimationFrame(() => this.panelTarget.classList.add("is-in"))
  }

  close() {
    if (!this.hasFrameTarget) return
    if (this.hasPanelTarget) this.panelTarget.classList.remove("is-in")
    this.frameTarget.removeAttribute("src")
    this.frameTarget.innerHTML = ""
    this.currentId = null
    this.markInspected()
    this.element.classList.remove("cloud--inspecting")
    this.select?.focusItem?.(this.select._focused || this.select.selectedItems[0] || this.fileItems()[0])
  }

  prev() { this.step(-1) }
  next() { this.step(1) }

  step(delta) {
    const items = this.fileItems()
    const index = items.findIndex((el) => el.dataset.itemId === this.currentId)
    const target = items[index + delta]
    if (!target) return
    this.select?.selectOnly(target)
    this.select?.focusItem(target)
    this.open(target)
  }

  keydown(event) {
    if (event.key === "Escape") { event.preventDefault(); event.stopPropagation(); this.close() }
  }

  updateNav() {
    const items = this.fileItems()
    const index = items.findIndex((el) => el.dataset.itemId === this.currentId)
    if (this.hasPrevBtnTarget) this.prevBtnTarget.disabled = index <= 0
    if (this.hasNextBtnTarget) this.nextBtnTarget.disabled = index === -1 || index >= items.length - 1
  }

  markInspected() {
    this.element.querySelectorAll("[data-cloud-item].is-inspected").forEach((el) => el.classList.remove("is-inspected"))
    if (!this.currentId) return
    this.element.querySelectorAll(`[data-cloud-item][data-item-id="${this.currentId}"]`).forEach((el) => el.classList.add("is-inspected"))
  }

  fileItems() { return visibleItems(this.element).filter((el) => el.dataset.peekUrl) }
  get isOpen() { return this.hasPanelTarget }
  get select() { return controllerFor(this.element, "cloud-select") }
}
